import { Paper, Modal, Typography, Box } from "@mui/material";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  modalBox: {
    position: "absolute",
    maxWidth: "310px",
    minWidth: "310px",
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "23px",
    [theme.breakpoints.down("360")]: {
      maxWidth: "260px",
      minWidth: "260px",
    },
  },
  closeBtn: {
    position: "absolute",
    top: "18px",
    right: "24px",
    color: "#ABACBE",
    cursor: "pointer",
  },
}));

function getModalStyle() {
  return {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    position: "absolute",
  };
}

const CustomModal = ({ openModal, setOpenModal, id, children, titleModal }) => {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Paper style={modalStyle} className={classes.modalBox}>
        <Box onClick={() => setOpenModal(false)} className={classes.closeBtn}>
          <Close />
        </Box>
        <Typography variant="h4" mb={4} textAlign="center" fontWeight="700">
          {titleModal}
        </Typography>
        {children}
      </Paper>
    </Modal>
  );
};
export default CustomModal;
